import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f541e1f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "subtle-box mb-3"
};
const _hoisted_2 = {
    key: 0,
    class: "table-title px-2"
};
const _hoisted_3 = { class: "table-responsive" };
const _hoisted_4 = { style: { "border-top": "0" } };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = /*#__PURE__*/ _createTextVNode("  ");
const _hoisted_8 = ["colspan"];
const _hoisted_9 = /*#__PURE__*/ _createTextVNode(" Download as ");
const _hoisted_10 = /*#__PURE__*/ _createTextVNode(", ");
const _hoisted_11 = /*#__PURE__*/ _createTextVNode(", or ");
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Icon = _resolveComponent("Icon");
    const _component_Tooltip = _resolveComponent("Tooltip");
    return (_ctx.tableDataToUse)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.tableDataToUse.headers.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.caption), 1))
                : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "afterHeader", {}, undefined, true),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("table", {
                    class: _normalizeClass('table table-striped table-hover table-sm mb-0 pb-0 table-borderless' +
                        (_ctx.noFixedTable ? '' : ' fixed-table'))
                }, [
                    _createElementVNode("thead", _hoisted_4, [
                        _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataToUse.headers, (header) => {
                                return (_openBlock(), _createElementBlock("th", {
                                    key: header.text,
                                    class: "sticky-header px-2 cell",
                                    style: _normalizeStyle('font-weight: 550;' +
                                        (header.width
                                            ? 'width:' + header.width + 'px;'
                                            : '') +
                                        (_ctx.isHeaderSortable(header)
                                            ? 'cursor: pointer;'
                                            : '')),
                                    onClick: ($event) => (_ctx.headerClick(header))
                                }, [
                                    (_ctx.isHeaderSortable(header))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                            _createVNode(_component_Icon, {
                                                style: { "color": "#212529" },
                                                icon: ['fa', _ctx.headerIcon(header)]
                                            }, null, 8, ["icon"]),
                                            _hoisted_7
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_Tooltip, {
                                        tip: _ctx.getHeaderToolTipText(header)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(header.text), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["tip"])
                                ], 12, _hoisted_5));
                            }), 128))
                        ])
                    ]),
                    _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("td", {
                                colspan: _ctx.tableData?.headers.length,
                                class: "px-2"
                            }, [
                                _hoisted_9,
                                _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_ctx.download('csv')), ["prevent"])),
                                    href: "#"
                                }, "CSV"),
                                _hoisted_10,
                                _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.download('xlsx')), ["prevent"])),
                                    href: "#"
                                }, "XLSX"),
                                _hoisted_11,
                                _createElementVNode("a", {
                                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_ctx.download('json')), ["prevent"])),
                                    href: "#"
                                }, "JSON")
                            ], 8, _hoisted_8)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataToUse.rows, (row, rowIdx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: rowIdx }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDataToUse.headers, (header) => {
                                    return (_openBlock(), _createElementBlock("td", {
                                        key: header.text,
                                        onClick: ($event) => (_ctx.rowClicked(rowIdx)),
                                        class: "cell px-2",
                                        style: _normalizeStyle(_ctx.clickableRows ? 'cursor: pointer;' : '')
                                    }, [
                                        _createVNode(_component_Tooltip, {
                                            tip: _ctx.getCellToolTipText(_ctx.getCell(row[header.text]))
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.getCell(row[header.text]).val) + " ", 1),
                                                (_ctx.showIcon(_ctx.getCell(row[header.text]), row))
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "icon-clickable",
                                                        onClick: _withModifiers(($event) => (_ctx.iconClicked(_ctx.getCell(row[header.text])
                                                            .iconClickEmitName, row)), ["stop"])
                                                    }, [
                                                        _createVNode(_component_Icon, {
                                                            icon: _ctx.getCell(row[header.text])
                                                                .iconClasses
                                                        }, null, 8, ["icon"])
                                                    ], 8, _hoisted_13))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                        }, 1032, ["tip"])
                                    ], 12, _hoisted_12));
                                }), 128))
                            ]));
                        }), 128))
                    ])
                ], 2)
            ])
        ]))
        : _createCommentVNode("", true);
}
